import styled from 'styled-components'
import { COLORS } from '../../../../styles/colors'
import { CALENDAR_DIMENSIONS } from '../../constants/constants'

interface StyledDayCellProps {
	$isSelected: boolean
	$isToday: boolean
	$isCurrentMonth: boolean
	$isDisabled: boolean
	$isInRange?: boolean
	$isRangeStart?: boolean
	$isRangeEnd?: boolean
}

export const StyledDayCell = styled.div<StyledDayCellProps>`
	width: ${CALENDAR_DIMENSIONS.DAY_CELL_SIZE}px;
	height: ${CALENDAR_DIMENSIONS.DAY_CELL_SIZE}px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: ${({ $isDisabled, $isCurrentMonth }) =>
		$isDisabled || !$isCurrentMonth ? 'not-allowed' : 'pointer'};
	position: relative;
	overflow: visible;
	transition: background 0.2s ease;

	/* Бордер в зависимости от состояния */
	border: 1px solid
		${({ $isSelected, $isRangeStart, $isRangeEnd, $isInRange }) => {
			// Для выбранных дат (с фиолетовым фоном) - прозрачный border
			if ($isSelected || $isRangeStart || $isRangeEnd || $isInRange) {
				return 'transparent'
			}
			// Для остальных - обычный border
			return COLORS.inputBorder
		}};

	/* Скругление углов - всегда 8px */
	border-radius: ${CALENDAR_DIMENSIONS.CELL_BORDER_RADIUS}px;

	/* Фон для выбранной даты */
	background: ${({ $isSelected, $isRangeStart, $isRangeEnd, $isInRange }) => {
		// Начало и конец диапазона - темно-фиолетовый
		if ($isSelected || $isRangeStart || $isRangeEnd) {
			return COLORS.main
		}
		// Середина диапазона - светло-фиолетовый
		if ($isInRange) {
			return COLORS.mainOpacity
		}
		return 'transparent'
	}};

	/* Цвет текста */
	color: ${({
		$isSelected,
		$isRangeStart,
		$isRangeEnd,
		$isInRange,
		$isCurrentMonth,
		$isDisabled,
	}) => {
		// Выбранная дата или края диапазона - белый текст
		if ($isSelected || $isRangeStart || $isRangeEnd || $isInRange) {
			return '#FFFFFF'
		}
		// Дата не из текущего месяца или disabled - серый
		if (!$isCurrentMonth || $isDisabled) {
			return COLORS.secondary
		}
		// Обычная дата - черный
		return COLORS.black
	}};

	/* Обводка для сегодняшнего дня (только если не выбрана) */
	${({ $isToday, $isSelected, $isRangeStart, $isRangeEnd }) =>
		$isToday && !$isSelected && !$isRangeStart && !$isRangeEnd
			? `
    border: 1px solid ${COLORS.main};
  `
			: ''}

	/* Hover эффект только для активных дат текущего месяца */
  &:hover {
		${({
			$isDisabled,
			$isCurrentMonth,
			$isSelected,
			$isRangeStart,
			$isRangeEnd,
		}) => {
			if ($isDisabled || !$isCurrentMonth) {
				return ''
			}
			if ($isSelected || $isRangeStart || $isRangeEnd) {
				return `
          background: ${COLORS.main};
          opacity: 0.9;
        `
			}
			return `
        background: ${COLORS.backgroundHover};
      `
		}}
	}

	/* Отключаем pointer events для disabled и дат не текущего месяца */
	${({ $isDisabled, $isCurrentMonth }) =>
		$isDisabled || !$isCurrentMonth
			? `
    pointer-events: none;
  `
			: ''}
`

export const DayCellContent = styled.span`
	font-weight: 400;
	font-size: 14px;
	line-height: 17px;
	position: relative;
	z-index: 2;
`

export const RangeArrow = styled.svg<{
	$position: 'left' | 'right'
	$isHovered: boolean
}>`
	position: absolute;
	${({ $position }) =>
		$position === 'right'
			? `right: -${CALENDAR_DIMENSIONS.CELL_GAP_HORIZONTAL / 2}px;`
			: `left: -${CALENDAR_DIMENSIONS.CELL_GAP_HORIZONTAL / 2}px;`}
	top: 50%;
	transform: translateY(-50%);
	width: ${CALENDAR_DIMENSIONS.CELL_GAP_HORIZONTAL}px;
	height: ${CALENDAR_DIMENSIONS.DAY_CELL_SIZE}px;
	z-index: 1;
`
